import { ResolveFn } from '@angular/router';
import { FormBuilderStore } from '../store/form-builder.store';
import { inject } from '@angular/core';
import { tap, of } from 'rxjs';

export const formBuilderListResolver: ResolveFn<boolean> = () => {
  const store = inject(FormBuilderStore);

  return of(true).pipe(
    tap(() => {
      store.loadFormTemplates();
    }),
  );
};
